<mat-card data-at-remote-diagnostics-force-disconnect-modal>
  <mat-card-header>
    <mat-card-title>
      {{ 'DIAGNOSTICS.FORCE_DISCONNECT_MODAL.TITLE' | translate }}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="green flex flex-row gap-[8px]">
      <mat-icon>check_circle_outline</mat-icon>
      <span>
        {{ 'DIAGNOSTICS.FORCE_DISCONNECT_MODAL.INSTALLATION_TEXT' | translate }}
        {{ data.gatewaySerial }}
        {{ 'DIAGNOSTICS.FORCE_DISCONNECT_MODAL.TEXT' | translate }}
        {{ ' (' + this.disconnectCounter + 's).' }}</span
      >
    </div>
  </mat-card-content>
  <mat-card-actions class="!flex flex-row gap-[8px] justify-end items-center">
    <button
      data-at-remote-diagnostics-force-disconnect-modal-confirm
      mat-raised-button
      color="primary"
      gtm="onConfirm"
      gtmAction="Remote diagnostics"
      gtmCategory="diagnosticsModal"
      (click)="extendSession()"
    >
      {{ 'GENERAL.BUTTON.EXTEND' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
